import { fetchWithTimeout } from './fetchWithTimeout';

const API_BASE = process.env.REACT_APP_API_URL || '';
const API_TIMEOUT_MS = 15000; // 15 second timeout for API calls

class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.status = status;
    this.data = data;
  }
}

async function request(method, endpoint, body = null) {
  const headers = {
    'Content-Type': 'application/json',
  };

  // Add auth header from localStorage as backup to cookie
  const token = localStorage.getItem('session_token');
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const config = {
    method,
    headers,
    credentials: 'include', // Include cookies
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  const response = await fetchWithTimeout(`${API_BASE}${endpoint}`, config, API_TIMEOUT_MS);
  
  // Handle timeout (null response)
  if (response === null) {
    throw new ApiError('Request timed out - service temporarily unavailable', 0, null);
  }

  let data;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    const message = data?.detail || `Request failed with status ${response.status}`;
    throw new ApiError(message, response.status, data);
  }

  return data;
}

const api = {
  get: (endpoint) => request('GET', endpoint),
  post: (endpoint, body) => request('POST', endpoint, body),
  put: (endpoint, body) => request('PUT', endpoint, body),
  delete: (endpoint) => request('DELETE', endpoint),
};

export default api;
export { ApiError };
